<template>
  <div @keyup.enter="valida">
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <card-header titulo="Formulário de Falta lei" />
                <div class="hidden-sm hidden-xs">
                  <impresso
                    via="1"
                    destino="DRH"
                    :nomeServidor="nomeFuncionario"
                    :servidor="funcionario"
                    :dataSolicitada="new Date()"
                    :dataDaFalta="new Date()"
                    :mostraDataSolicitada="true"
                    :mostraDataFalta="true"
                    @getDataSolicitada="pegaSolicitada"
                    @getDataFalta="pegaFalta"
                  />
                  <div class="col-md-12 footer-controller-inner">
                    <botao
                      estilo="cheio-verde-dir"
                      rotulo="Imprimir"
                      icone="fa fa-print"
                      toggle
                      target
                      @clicado="valida()"
                    ></botao>
                    <botao
                      estilo="vazado-verde-esq"
                      rotulo="Voltar"
                      icone="voltar"
                      toggle
                      target
                      @clicado="anteriorLink()"
                    ></botao>
                  </div>
                </div>
                <div class="hidden-md hidden-lg">
                  <div style="margin-bottom: 30px;">
                    <p>
                      O formulário de <strong>Falta Lei</strong> não pode ser
                      impresso via celular. Acesse essa tela em um
                      <strong>desktop</strong> ou <strong>notebook</strong> para
                      imprimi-lo sem problemas.
                    </p>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller hidden-md hidden-lg">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao
              estilo="vazado-verde-esq"
              rotulo="Voltar"
              icone="voltar"
              @clicado="anteriorLink()"
            ></botao>
            <botao
              estilo="cheio-verde-dir"
              rotulo="Imprimir"
              icone="fa fa-print"
              toggle
              target
              v-if="!telaEhMobile"
              @clicado="valida()"
            ></botao>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CardHeader from '@/components/card-header';
import Impresso from './impresso';
import DateHelper from '@/helpers/DateHelper';

export default {
  name: 'FaltaLei',
  components: {
    Botao,
    Impresso,
    CardHeader,
  },
  data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario,
      nomeFuncionario: this.$store.state.usuarioLogado.nome,
      dataSolicitacao: '',
      dataFalta: '',
      dataSolicitacaoSm: '',
      dataFaltaSm: '',
    };
  },
  computed: {
    telaEhMobile() {
      return window.innerWidth <= 768;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
  },
  methods: {
    pegaSolicitada(solicitacao) {
      this.dataSolicitacao = solicitacao;
    },
    pegaFalta(falta) {
      this.dataFalta = falta;
    },
    valida() {
      this.buscaDatas();
      const diaSolicitado = DateHelper.convertDateToApiDate(
        this.dataSolicitacao,
      );
      const diaAbonado = DateHelper.convertDateToApiDate(this.dataFalta);
      if (
        this.dataSolicitacao &&
        this.dataFalta &&
        diaSolicitado < diaAbonado
      ) {
        this.gerar();
        return;
      }
      this.$root.$refs.toastr.e(
        'Data da solicitação deve ser anterior à data da falta abonada.',
        'Atenção',
      );
    },
    buscaDatas() {
      if (this.dataSolicitacaoSm && this.dataFaltaSm) {
        this.dataSolicitacao = DateHelper.convertDateToPtbr(
          this.dataSolicitacaoSm,
        );
        this.dataFalta = DateHelper.convertDateToPtbr(this.dataFaltaSm);
        return;
      }
      this.$emit('enviaDatas');
    },
    gerar() {
      const indexFuncionario = this.autenticados.findIndex(autenticado => {
        return autenticado.id === this.funcionario.id;
      });

      this.$router.push({
        name: 'FaltaLeiImpresso',
        params: {
          diaFalta: this.dataFalta.split('/')[0],
          mesFalta: this.dataFalta.split('/')[1],
          anoFalta: this.dataFalta.split('/')[2],
          diaSolicitacao: this.dataSolicitacao.split('/')[0],
          mesSolicitacao: this.dataSolicitacao.split('/')[1],
          anoSolicitacao: this.dataSolicitacao.split('/')[2],
          index: indexFuncionario,
        },
      });
    },
    anteriorLink() {
      this.$router.go(-1);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?08b2d546